<div class="ibox detailed-view-ibox" *ngIf="directoryService.showDetailedView && data">
    <div class="detailed-view-header">
        <a *ngIf="data.suiteNumber" [routerLink]="['/directory/item/' + data.id + '/info']">
			<span class="suite-name m-r-sm mtv-primary-color">{{data.suiteNumber}}</span>
        </a>
        <span class="building-name">{{data.buildingName || 'Create' + title}}</span>
        <span class="close-detailed-view" (click)="directoryService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
        <form #form="ngForm" submittable class="directory-detailed-view-content m-t-md">
            <input type="hidden" name="id" [ngModel]="data.id">

            <!--** Building ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'building', true)">
                <div class="dv-label col-sm-4 strong">Building</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.building.editMode">
                    <span>{{data.buildingName || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'building', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.building.editMode">
                    <select class="form-control" name="building" [ngModel]="data.building" required>
                        <option value="" hidden></option>
                        <option *ngFor="let build of directoryService.buildings"
                                [value]="build.id">{{build.name}}
                        </option>
                    </select>
                    <button type="button" (click)="applyChanges(data, form, 'building')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'building', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** SUITE NUMBER ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'suiteNumber', true)">
                <div class="dv-label col-sm-4 strong">Unit Number</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.suiteNumber.editMode">
                    <span>{{data.suiteNumber || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'suiteNumber', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.suiteNumber.editMode">
                    <input class="form-control" name="suiteNumber" [ngModel]="data.suiteNumber" required maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'suiteNumber')">
                    <button type="button" (click)="applyChanges(data, form, 'suiteNumber')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'suiteNumber', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <hr>

            <!--** Emergency Contact ** -->
            <emergency-contacts-field [ngModel]="data.emergencyContacts"
                                      name="emergencyContacts"
                                      [title]="'Emerg. Cont.'"
                                      [labelClass]="'col-md-4'"
                                      [contentClass]="'col-md-8'"
                                      [propertyName]="'user'"
                                      [users]="data.suiteUser"
                                      (update)="applyChanges(data, form, 'emergencyContacts')"
                                      [noEdit]="!data.isCanEdit"></emergency-contacts-field>

            <hr>

            <!--** Instructions ** -->
            <div class="row m-b-xs" *ngIf="data.instructions.length > 0">
                <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                    Instructions
                </div>

                <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                     *ngIf="!showInstructionsHistory && numberOfCurrentInstructions() < data.instructions.length"
                     (click)="showInstructionsHistory = true">
                    + Show Instructions History
                </div>

                <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                     *ngIf="showInstructionsHistory || numberOfCurrentInstructions() == data.instructions.length"
                     (click)="showInstructionsHistory = false">
                    - Hide Instructions History
                </div>
            </div>

            <div class="row m-b-xs resident-instructions-row"
                 *ngFor="let instruction of getInstructions(); let index = index;">
                <div class="col-sm-12 m-b-xs">
                    <label>{{instruction.subject}}</label>
                    <pre>{{instruction.text}}</pre>
                </div>
                <div class="dv-label col-sm-12">
                    <span class="same-label-width label label-{{instruction.status}} m-r-sm">{{instruction.status}}</span>
                    {{instruction.startDate | date:'dd.MM.yyyy'}} <span *ngIf="instruction.endDate"> - {{instruction.endDate | date:'dd.MM.yyyy'}}</span>
                </div>
                <div class="dv-label col-sm-12">
                    Assigned to: {{instruction.user?.fullName}}
                    <i *ngIf="data.isCanDelete"
                       class="fa fa-trash pull-right"
                       (click)="directoryService.deleteInstructionFromUnit(instruction)">
                    </i>
                    <i *ngIf="data.isCanEdit"
                       (click)="directoryService.editInstructionFromUnitView(instruction)"
                       class="fa fa-pencil pull-right">
                    </i>
                </div>
            </div>

            <hr *ngIf="data.instructions.length > 0">

            <!--** Level ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'level', true)">
                <div class="dv-label col-sm-4 strong">Level</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.level.editMode">
                    <span>{{data.level || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'level', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.level.editMode">
                    <input class="form-control" name="level" [ngModel]="data.level" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'level')">
                    <button type="button" (click)="applyChanges(data, form, 'level')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'level', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** Sub Name ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'subName', true)">
                <div class="dv-label col-sm-4 strong">Sub Name</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.subName.editMode">
                    <span>{{data.subName || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'subName', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.subName.editMode">
                    <input class="form-control" name="subName" [ngModel]="data.subName" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'subName')">
                    <button type="button" (click)="applyChanges(data, form, 'subName')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'subName', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** Enter Phone ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'enterPhone', true)">
                <div class="dv-label col-sm-4 strong">Enter Phone</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.enterPhone.editMode">
                    <span>{{data.enterPhone || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'enterPhone', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.enterPhone.editMode">
                    <input class="form-control" name="enterPhone" [ngModel]="data.enterPhone" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'enterPhone')">
                    <button type="button" (click)="applyChanges(data, form, 'enterPhone')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'enterPhone', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** Form Five Received ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'fromFiveReceived', true)">
                <div class="dv-label col-sm-4 strong">Form Five Received</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.fromFiveReceived.editMode">
                    <i *ngIf="data.fromFiveReceived == 1" class="icon-check"></i>
                    <i *ngIf="data.fromFiveReceived == 0" class="icon-close"></i>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'fromFiveReceived', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.fromFiveReceived.editMode">
                    <select class="form-control" name="fromFiveReceived" [ngModel]="data.fromFiveReceived">
                        <option [value]="1">Yes</option>
                        <option [value]="0">No</option>
                    </select>
                    <button type="button" (click)="applyChanges(data, form, 'fromFiveReceived')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'fromFiveReceived', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** Prop. Share %: ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'proportionateShare', true)">
                <div class="dv-label col-sm-4 strong">Prop. Share %</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.proportionateShare.editMode">
                    <span>{{data.proportionateShare || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'proportionateShare', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.proportionateShare.editMode">
                    <input class="form-control" name="proportionateShare" [ngModel]="data.proportionateShare" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'proportionateShare')">
                    <button type="button" (click)="applyChanges(data, form, 'proportionateShare')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'proportionateShare', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** Common Elements Fee: ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'commonElementsFee', true)">
                <div class="dv-label col-sm-4 strong">Common Elements Fee</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.commonElementsFee.editMode">
                    <span>{{data.commonElementsFee || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'commonElementsFee', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.commonElementsFee.editMode">
                    <input class="form-control" name="commonElementsFee" [ngModel]="data.commonElementsFee" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'commonElementsFee')">
                    <button type="button" (click)="applyChanges(data, form, 'commonElementsFee')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'commonElementsFee', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** OCCUPANCY DATE ** -->
            <datetime-field
                ngModel
                name="occupancyDate"
                [title]="'Occupancy Date'"
                [value]="data.occupancyDate"
                [noEdit]="!data.isCanEdit"
                (update)="applyChangesForDate(data, form, 'occupancyDate')">
            </datetime-field>

            <hr>

            <!--** Buzz ** -->
            <div class="row m-b-xs company-view" (dblclick)="setEditModeFor(data, 'buzz', true)">
                <div class="dv-label col-sm-4 strong">Buzz</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.buzz.editMode && data.buzzFields.length > 0">
                    <div *ngFor="let buzz of data.buzzFields; let index = index;"
                         style="position: relative;"
                         class="array-row display-flex m-b-xs">
                        <div title="{{buzz.fieldValue}} {{buzz.user ? getUserNameById(buzz.user) : 'Unassigned'}}">
                            {{buzz.fieldValue}} {{buzz.user ? getUserNameById(buzz.user) : 'Unassigned'}}
                        </div>
                        <i *ngIf="data.isCanEdit"
                           style="line-height: 18px; position: absolute; right: 15px;"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'buzz', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'buzz', form)"
                           style="line-height: 18px; position: absolute; right: 0;"
                           class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                    </div>
                </div>
                <div class="dv-value col-sm-8 array-row"
                     style="position: relative;"
                     *ngIf="!data.formFields.buzz.editMode && data.buzzFields.length < 1">
                    -
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                       (click)="setEditModeFor(data, 'buzz', true)"
                       style="line-height: 18px; position: absolute; right: 15px;"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'buzz', form)"
                       style="line-height: 18px; position: absolute; right: 0;"
                       class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.buzz.editMode" style="display: block;">
                    <div *ngFor="let buzz of data.buzzFields; let index = index;" class="display-flex m-b-xs">
                        <input class="form-control"
                               name="buzzFieldsFieldValue{{index}}"
                               [ngModel]="buzz.fieldValue"
                               maxlength="255"
                               style="width: 70px;">
                        <select class="form-control" name="buzzFieldsUser{{index}}" [ngModel]="buzz.user" style="padding: 0px 6px;">
                            <option [ngValue]="null">Unassigned</option>
                            <option *ngFor="let user of data.suiteUser; let index = index" [value]="user.user?.id">
                                {{user.user?.fullName}}
                            </option>
                        </select>
                        <button type="button" (click)="applyArrayFieldChanges(form, 'buzzFields')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="cancelArrayFieldsChanges(data, 'buzz', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="data.formFields.buzz.editMode">
                    <i class="icon-plus pull-right" (click)="addNew('buzz')" style="opacity: 1"
                       data-toggle="tooltip" data-placement="top" title="Add New Address"></i>
                </div>
            </div>

            <!--** keyCode ** -->
            <div class="row m-b-xs company-view" (dblclick)="setEditModeFor(data, 'keyCode', true)">
                <div class="dv-label col-sm-4 strong">Key Code</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.keyCode.editMode && data.keyCodeFields.length > 0">
                    <div *ngFor="let keyCode of data.keyCodeFields; let index = index;"
                         style="position: relative;"
                         class="array-row display-flex m-b-xs">
                        <div title="{{keyCode.fieldValue}} {{keyCode.user ? getUserNameById(keyCode.user) : 'Unassigned'}}">
                            {{keyCode.fieldValue}} {{keyCode.user ? getUserNameById(keyCode.user) : 'Unassigned'}}
                        </div>
                        <i *ngIf="data.isCanEdit"
                           style="line-height: 18px; position: absolute; right: 15px;"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'keyCode', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'keyCode', form)"
                           style="line-height: 18px; position: absolute; right: 0;"
                           class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                    </div>
                </div>
                <div class="dv-value col-sm-8 array-row"
                     style="position: relative;"
                     *ngIf="!data.formFields.keyCode.editMode && data.keyCodeFields.length < 1">
                    -
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                       (click)="setEditModeFor(data, 'keyCode', true)"
                       style="line-height: 18px; position: absolute; right: 15px;"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'keyCode', form)"
                       style="line-height: 18px; position: absolute; right: 0;"
                       class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.keyCode.editMode" style="display: block;">
                    <div *ngFor="let keyCode of data.keyCodeFields; let index = index;" class="display-flex m-b-xs">
                        <input class="form-control"
                               name="keyCodeFieldsFieldValue{{index}}"
                               [ngModel]="keyCode.fieldValue"
                               maxlength="255"
                               style="width: 70px;">
                        <select class="form-control" name="keyCodeFieldsUser{{index}}" [ngModel]="keyCode.user" style="padding: 0px 6px;">
                            <option [ngValue]="null">Unassigned</option>
                            <option *ngFor="let user of data.suiteUser; let index = index" [value]="user.user?.id">
                                {{user.user?.fullName}}
                            </option>
                        </select>
                        <button type="button" (click)="applyArrayFieldChanges(form, 'keyCodeFields')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="cancelArrayFieldsChanges(data, 'keyCode', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="data.formFields.keyCode.editMode">
                    <i class="icon-plus pull-right" (click)="addNew('keyCode')" style="opacity: 1"
                       data-toggle="tooltip" data-placement="top" title="Add New Address"></i>
                </div>
            </div>

            <!--** keyFob ** -->
            <div class="row m-b-xs company-view" (dblclick)="setEditModeFor(data, 'keyFob', true)">
                <div class="dv-label col-sm-4 strong">Key Fob</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.keyFob.editMode && data.keyFobFields.length > 0">
                    <div *ngFor="let keyFob of data.keyFobFields; let index = index;"
                         style="position: relative;"
                         class="array-row display-flex m-b-xs">
                        <div title="{{keyFob.fieldValue}} {{keyFob.user ? getUserNameById(keyFob.user) : 'Unassigned'}}">
                            {{keyFob.fieldValue}} {{keyFob.user ? getUserNameById(keyFob.user) : 'Unassigned'}}
                        </div>
                        <i *ngIf="data.isCanEdit"
                           style="line-height: 18px; position: absolute; right: 15px;"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(data, 'keyFob', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'keyFob', form)"
                           style="line-height: 18px; position: absolute; right: 0;"
                           class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                    </div>
                </div>
                <div class="dv-value col-sm-8 array-row"
                     style="position: relative;"
                     *ngIf="!data.formFields.keyFob.editMode && data.keyFobFields.length < 1">
                    -
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right"
                       (click)="setEditModeFor(data, 'keyFob', true)"
                       style="line-height: 18px; position: absolute; right: 15px;"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    <i *ngIf="data.isCanEdit" (click)="removeItem(index, 'keyFob', form)"
                       style="line-height: 18px; position: absolute; right: 0;"
                       class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top" title="Delete"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.keyFob.editMode" style="display: block;">
                    <div *ngFor="let keyFob of data.keyFobFields; let index = index;" class="display-flex m-b-xs">
                        <input class="form-control"
                               name="keyFobFieldsFieldValue{{index}}"
                               [ngModel]="keyFob.fieldValue"
                               maxlength="255"
                               style="width: 70px;">
                        <select class="form-control" name="keyFobFieldsUser{{index}}" [ngModel]="keyFob.user" style="padding: 0px 6px;">
                            <option [ngValue]="null">Unassigned</option>
                            <option *ngFor="let user of data.suiteUser; let index = index" [value]="user.user?.id">
                                {{user.user?.fullName}}
                            </option>
                        </select>
                        <button type="button" (click)="applyArrayFieldChanges(form, 'keyFobFields')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="cancelArrayFieldsChanges(data, 'keyFob', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="col-sm-12" *ngIf="data.formFields.keyFob.editMode">
                    <i class="icon-plus pull-right" (click)="addNew('keyFob')" style="opacity: 1"
                       data-toggle="tooltip" data-placement="top" title="Add New Address"></i>
                </div>
            </div>

            <hr>

            <!--** POWER_ATTORNEY ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'powerAttorney', true)">
                <div class="dv-label col-sm-4 strong">Power Attorney</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.powerAttorney.editMode">
                    <span>{{data.powerAttorney || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'powerAttorney', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.powerAttorney.editMode">
                    <input class="form-control" name="powerAttorney" [ngModel]="data.powerAttorney" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'powerAttorney')">
                    <button type="button" (click)="applyChanges(data, form, 'powerAttorney')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'powerAttorney', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** legalDescription ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'legalDescription', true)">
                <div class="dv-label col-sm-4 strong">Legal Description</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.legalDescription.editMode">
                    <span>{{data.legalDescription || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'legalDescription', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.legalDescription.editMode">
                    <input class="form-control" name="legalDescription" [ngModel]="data.legalDescription" maxlength="255"
                           (keyup.enter)="applyChanges(data, form, 'legalDescription')">
                    <button type="button" (click)="applyChanges(data, form, 'legalDescription')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'legalDescription', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <hr>

            <!--** rentedOut ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'rentedOut', true)">
                <div class="dv-label col-sm-4 strong">Rented Out</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.rentedOut.editMode">
                    <i *ngIf="data.rentedOut == 1" class="icon-check"></i>
                    <i *ngIf="data.rentedOut == 0" class="icon-close"></i>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'rentedOut', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value-edit col-sm-8" *ngIf="data.formFields.rentedOut.editMode">
                    <select class="form-control" name="rentedOut" [ngModel]="data.rentedOut">
                        <option [value]="1">Yes</option>
                        <option [value]="0">No</option>
                    </select>
                    <button type="button" (click)="applyChanges(data, form, 'rentedOut')"   ><i class="fa fa-check"></i></button>
                    <button type="button" (click)="setEditModeFor(data, 'rentedOut', false)"><i class="fa fa-times"></i></button>
                </div>
            </div>

            <!--** note ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'note', true)">
                <div class="dv-label col-sm-4 strong">Notes</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.note.editMode">
                    <pre>{{data.note || '-'}}</pre>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'note', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value col-sm-8" *ngIf="data.formFields.note.editMode">
                    <textarea class="form-control" name="note" [ngModel]="data.note" maxlength="255"
                              (keyup.enter)="applyChanges(data, form, 'note')">{{data.note}}</textarea>
                    <div class="m-t-xs apart-btns pull-right">
                        <button type="button" class="apply" (click)="applyChanges(data, form, 'note')"><i class="fa fa-check"></i></button>
                        <button type="button" class="reset" (click)="setEditModeFor(data, 'note', false)"><i class="fa fa-times"></i></button>
                    </div>
                </div>
            </div>

            <!--** allowedVisitor ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'allowedVisitor', true)">
                <div class="dv-label col-sm-4 strong">Allowed Visitors</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.allowedVisitor.editMode">
                    <span>{{data.allowedVisitor || '-'}}</span>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'allowedVisitor', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value col-sm-8" *ngIf="data.formFields.allowedVisitor.editMode">
                    <textarea class="form-control" name="allowedVisitor" [ngModel]="data.allowedVisitor" maxlength="255"
                              (keyup.enter)="applyChanges(data, form, 'allowedVisitor')">{{data.allowedVisitor}}</textarea>
                    <div class="m-t-xs apart-btns pull-right">
                        <button type="button" class="apply" (click)="applyChanges(data, form, 'allowedVisitor')"><i class="fa fa-check"></i></button>
                        <button type="button" class="reset" (click)="setEditModeFor(data, 'allowedVisitor', false)"><i class="fa fa-times"></i></button>
                    </div>
                </div>
            </div>

            <!--** Permission To Enter ** -->
            <div class="row m-b-xs" (dblclick)="setEditModeFor(data, 'permissionToEnter', true)">
                <div class="dv-label col-sm-4 strong">Permission To Enter</div>
                <div class="dv-value col-sm-8" *ngIf="!data.formFields.permissionToEnter.editMode">
                    <pre>{{data.permissionToEnter || '-'}}</pre>
                    <i *ngIf="data.isCanEdit" class="fa fa-pencil pull-right" (click)="setEditModeFor(data, 'permissionToEnter', true)"
                       data-toggle="tooltip" data-placement="top" title="Edit"></i>
                </div>
                <div class="dv-value col-sm-8" *ngIf="data.formFields.permissionToEnter.editMode">
                    <textarea class="form-control" name="permissionToEnter" [ngModel]="data.permissionToEnter"
                           maxlength="255" (keyup.enter)="applyChanges(data, form, 'permissionToEnter')">
                        {{data.permissionToEnter}}
                    </textarea>
                    <div class="m-t-xs apart-btns pull-right">
                        <button type="button" class="apply" (click)="applyChanges(data, form, 'permissionToEnter')"><i class="fa fa-check"></i></button>
                        <button type="button" class="reset" (click)="setEditModeFor(data, 'permissionToEnter', false)"><i class="fa fa-times"></i></button>
                    </div>
                </div>
            </div>
        </form>

        <hr *ngIf="data.isCanDelete">

        <div *ngIf="data.isCanDelete" class="btn-group dropup directory-actions">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <li (click)="remove(data.id)"><a>Delete This {{title}}</a></li>
            </ul>
        </div>
    </div>
</div>









// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/unit-view/unit-view.component.html